import React from 'react';
import { ImageOption, PhotoCredit } from '../styles/BackgroundPicker.styles';

const ImageCard = ({ image, onSelect }) => (
    <div>
        <ImageOption
            url={image.urls.small}
            onClick={() => onSelect(image)}
        />
        <PhotoCredit>
            Photo by{' '}
            <a
                href={image.user.links.html}
                target="_blank"
                rel="noopener noreferrer"
            >
                {image.user.name}
            </a>
        </PhotoCredit>
    </div>
);

export default ImageCard;